import { getConfig } from './config'

export type Question = {
  title: string,
  text: string
}

export const get = async (): Promise<Question[]> => {
  const config = getConfig()
  const response = await config.axios.get<Question[]>(`${config.API_URL}/helpers/faq`)

  return response.data
}
